<div [ngClass]="!desktopView ? 'container' : null">
  @if (searchInput) {
    <div nxRow>
      <div nxCol="6" class="items-per-page">
        <span class="result-label lbl">
          {{ this.count }} results for {{ searchInput }}
        </span>
      </div>
      <div
        nxCol="12"
        class="d-flex justify-content-flex-center pagination-content"
      >
        <nx-pagination
          class="std-pd-top-10"
          [count]="count"
          [page]="curPageSelected"
          [perPage]="perPageSelected"
          (goPrev)="prevPage()"
          (goNext)="nextPage()"
          (goPage)="goToPage($event)"
        >
        </nx-pagination>
      </div>
    </div>
  }
</div>
